import React from 'react';
import { StyleSheet } from 'react-native';
import Button from 'design-system/Button';
import Modal from 'utils/packages/Modal';
import { rem } from 'design-system/values';
import SafeAreaBottom from 'design-system/SafeAreaBottom';
import AddToWatchListModalContent from './AddToWatchListModalContent';
const defaultModalHeight = 7 * rem(78) + rem(14);
export const AddToWatchListModal = {
    show: (watchlistsLength, assetId) => {
        const watchlistHeight = watchlistsLength * rem(78) + rem(78) + rem(14);
        const finalHeight = Math.min(defaultModalHeight, watchlistHeight);
        Modal.show(<AddToWatchListModalContent closeModal={Modal.hide} assetId={assetId}/>, {
            containerStyle: styles.modal,
            title: 'Add to list',
            scrollable: {
                maxHeight: finalHeight,
                outsideContent: (<SafeAreaBottom style={styles.btnContainer}>
            <Button brand title="Done" onPress={Modal.hide}/>
          </SafeAreaBottom>),
            },
        });
    },
    hide: () => {
        Modal.hide();
    },
};
const styles = StyleSheet.create({
    modal: {
        paddingHorizontal: 0,
        overflow: 'hidden',
    },
    btnContainer: {
        paddingHorizontal: rem(16),
    },
});
